import React, { createContext, useContext, useState } from 'react'

const ClinicAdminContext = createContext();

export const ClinicProvider = (props) => {
	const [clinicAdmin, setClinicAdmin] = useState(() => {
		const saved = localStorage.getItem('currentHospitalAdmin');
    return saved ? JSON.parse(saved) : null;
	});

	return (
		<ClinicAdminContext.Provider value={{ ...props, clinicAdmin, setClinicAdmin }}>
      {props.children}
    </ClinicAdminContext.Provider>
	)
}

export const  useClinicAdmin = () => useContext(ClinicAdminContext);